"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cachingConfig = void 0;

var tslib_1 = require("tslib");

var extras_1 = require("@urql/exchange-graphcache/extras");

var object_fromentries_1 = (0, tslib_1.__importDefault)(require("object.fromentries"));
var introspection_1 = (0, tslib_1.__importDefault)(require("./introspection"));

var speaker_mutation_1 = require("./speaker-mutation");

var cachingConfig = function cachingConfig() {
  return {
    schema: introspection_1.default,
    keys: (0, tslib_1.__assign)({}, defaultKeyConfig()),
    updates: {
      Mutation: (0, tslib_1.__assign)({
        eventDelete: function eventDelete(_result, args, cache, _info) {
          cache.invalidate({
            __typename: 'Event',
            id: args.input.eventId
          });
        },
        organizationMemberInvitationAccept: function organizationMemberInvitationAccept(_result, args, cache, _info) {
          cache.invalidate({
            __typename: 'OrganizationInvitation',
            id: args.input.invitationId
          });
          invalidateUserKey(cache, 'organizations');
        },
        organizationMemberInvitationReject: function organizationMemberInvitationReject(_result, args, cache, _info) {
          cache.invalidate({
            __typename: 'OrganizationInvitation',
            id: args.input.invitationId
          });
        },
        organizationMemberRemove: function organizationMemberRemove(_result, args, cache, _info) {
          var orgEntity = {
            __typename: 'Organization',
            id: args.input.organizationId
          };
          cache.invalidate({
            __typename: 'OrganizationMember',
            id: args.input.memberId
          });
          cache.invalidate(orgEntity, 'hasReachedOrganiserLimit');
          cache.invalidate(orgEntity, 'paymentPlan');
        },
        organizationCreate: function organizationCreate(_r, _a, cache) {
          invalidateUserKey(cache, 'organizations');
        },
        organizationMemberInvitationCancel: function organizationMemberInvitationCancel(result, args, cache, _info) {
          var _b, _c;

          var org = (_c = (_b = result.organizationMemberInvitationCancel) === null || _b === void 0 ? void 0 : _b.invitation) === null || _c === void 0 ? void 0 : _c.organization;
          cache.invalidate({
            __typename: 'OrganizationInvitation',
            id: args.input.invitationId
          });

          if (org) {
            var orgEntity = {
              __typename: 'Organization',
              id: org.id
            };
            cache.invalidate(orgEntity, 'hasReachedOrganiserLimit');
            cache.invalidate(orgEntity, 'pendingMemberInvitationsCount');
          }
        },
        organizationMemberInvitationSend: function organizationMemberInvitationSend(_result, args, cache, _info) {
          var orgEntity = {
            __typename: 'Organization',
            id: args.input.organizationId
          };
          cache.inspectFields(orgEntity).filter(function (field) {
            return field.fieldName === 'memberInvitations';
          }).map(function (field) {
            return cache.invalidate(orgEntity, field.fieldKey);
          });
          cache.invalidate(orgEntity, 'hasReachedOrganiserLimit');
          cache.invalidate(orgEntity, 'pendingMemberInvitationsCount');
        },
        organizationMemberEventAccessUpdate: function organizationMemberEventAccessUpdate(_result, args, cache, _info) {
          var eventEntity = {
            __typename: 'Event',
            id: args.input.eventId
          };
          cache.inspectFields(eventEntity).filter(function (field) {
            return field.fieldName === 'organizationMembersWithAccess' || field.fieldName === 'organizationMembersWithoutAccess';
          }).map(function (field) {
            return cache.invalidate(eventEntity, field.fieldKey);
          });
        },
        organizationMemberEventAccessBulkUpdateAll: function organizationMemberEventAccessBulkUpdateAll(_result, args, cache, _info) {
          var eventEntity = {
            __typename: 'Event',
            id: args.input.eventId
          };
          cache.inspectFields(eventEntity).filter(function (field) {
            return field.fieldName === 'organizationMembersWithAccess' || field.fieldName === 'organizationMembersWithoutAccess';
          }).map(function (field) {
            return cache.invalidate(eventEntity, field.fieldKey);
          });
        },
        userConnectionDelete: function userConnectionDelete(_, args, cache) {
          cache.invalidate({
            __typename: 'EventRegistrantProfile',
            id: args.input.registrantId
          });
        }
      }, speaker_mutation_1.speakerMutationUpdates)
    },
    resolvers: {
      Organization: {
        events: (0, extras_1.relayPagination)(),
        members: (0, extras_1.relayPagination)(),
        memberInvitations: (0, extras_1.relayPagination)()
      },
      Event: {
        organizationMembersWithoutAccess: (0, extras_1.relayPagination)(),
        organizationMembersWithAccess: (0, extras_1.relayPagination)(),
        speakers: (0, extras_1.relayPagination)()
      },
      User: {
        organizations: (0, extras_1.relayPagination)(),
        vendorBooths: (0, extras_1.relayPagination)()
      }
    }
  };
};

exports.cachingConfig = cachingConfig;

var invalidateUserKey = function invalidateUserKey(cache, key) {
  var queryKey = 'Query';
  var userKey = cache.inspectFields(queryKey).filter(function (field) {
    return field.fieldName == 'me';
  }).map(function (meField) {
    return cache.resolve(queryKey, meField.fieldKey);
  })[0];
  cache.inspectFields(userKey).filter(function (field) {
    return field.fieldName === key;
  }).forEach(function (field) {
    cache.invalidate(userKey, field.fieldKey);
  });
};

var defaultKeyConfig = function defaultKeyConfig() {
  var pairs = introspection_1.default.__schema.types.filter(isObject).map(function (obj) {
    var hasId = obj.fields.some(function (field) {
      return isId(field.type);
    });

    if (hasId) {
      return [obj.name, function (entity) {
        return entity === null || entity === void 0 ? void 0 : entity.id;
      }];
    } else {
      return [obj.name, function () {
        return null;
      }];
    }
  });

  return (0, object_fromentries_1.default)(pairs);
};

var isObject = function isObject(type) {
  return type.kind == 'OBJECT';
};

var isId = function isId(type) {
  var _b, _c;

  return type.kind === 'NON_NULL' && ((_b = type.ofType) === null || _b === void 0 ? void 0 : _b.kind) === 'SCALAR' && ((_c = type.ofType) === null || _c === void 0 ? void 0 : _c.name) === 'ID';
};